import React, {Fragment} from 'react';
import classnames from 'classnames'
import './style.scss'

const BreadcrumbBlock = props => {
    const {breadSource = [],extra} = props;
    const handleClick = (item) => {
        if (!item.click || typeof item.click !== "function") {
            return
        }
        item.click()
    };
    return (
        <Fragment>
            <div className="breadcrumb-block-box">
                <div className="breadcrumb-block-main">
                    {
                        breadSource.map((item, index) => {
                            const cls = classnames('breadcrumb-link', {
                                'txt-hover': item.click
                            });
                            return (
                                <span className="breadcrumb-card" key={index}>
                                    <span className={cls} role="none" onClick={() => handleClick(item)} title={item.name}>{item.name}</span>
                                    <span className="breadcrumb-separator">/</span>
                                </span>
                            )
                        })
                    }
                </div>
                {extra && extra}
            </div>
            <div className="cut-off-rule"/>
        </Fragment>
    )
};
export default BreadcrumbBlock
